import { render } from "./modal_charges.vue?vue&type=template&id=0841f640&scoped=true"
import script from "./modal_charges.vue?vue&type=script&lang=js"
export * from "./modal_charges.vue?vue&type=script&lang=js"

import "./modal_charges.vue?vue&type=style&index=0&id=0841f640&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0841f640"]])

export default __exports__